import { render, staticRenderFns } from "./changeNotificationListener.vue?vue&type=template&id=4f2f3f04"
import script from "./changeNotificationListener.vue?vue&type=script&lang=js"
export * from "./changeNotificationListener.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports